// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-nav-button[data-v-dfb35b28]{background-color:#fff;border:none;min-width:auto}.mobile-nav-button svg[data-v-dfb35b28]{fill:#e70095;height:24px;width:24px}.btn.btn-secondary[data-v-dfb35b28]:not(:disabled):not(.disabled):focus{background-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
